import { render, staticRenderFns } from "./CreateKostDialog.vue?vue&type=template&id=4120e69a&scoped=true"
import script from "./CreateKostDialog.vue?vue&type=script&lang=js"
export * from "./CreateKostDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateKostDialog.vue?vue&type=style&index=0&id=4120e69a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4120e69a",
  null
  
)

export default component.exports